// extracted by mini-css-extract-plugin
export default {"author":"Item_author__Gb7ek","content":"Item_content__6CXrX","date":"Item_date__qxgsp","text":"Item_text__ASgDb","user":"Item_user__42XWH"};